import { useOrdersStore, useUIStore } from '../../../../store'
import { useMainHomeLogic } from '../../../../hooks/useMainHomeLogic'
import { MainPlates } from '../../cards/MainPlates'
import { MenuPlates } from '../../cards/MenuPlates'
import { PlateModal } from "../../modals/PlateModal"
import { Cart } from '../Cart'
import { TotalCart } from '../TotalCart'
import styles from './MainHome.module.scss'
import { CarrouselCategories } from '../../cards/CarrouselCategories'

export const MainHome = () => {
  const {
    menuData,
    orders,
    total,
    plateToShow,
    cartItemToEdit,
    handleCloseModal,
    isModalVisible,
    section,
  } = useMainHomeLogic();

  const showSearch = useUIStore((s) => s.showSearch);
  const canUseCart = useOrdersStore((s) => s.canUseCart);

  const isHome = section === "home";
  const isCart = section === "cart";
  const isModal = section === "productModal";

  return (
    <>
      <div className={styles.mainContainer}>

        {/* COLUMNA IZQUIERDA — contenido principal */}
        <div className={styles.contentColumn}>
          <div className={showSearch ? styles.hidden : undefined}>
            <MainPlates />
          </div>
          <CarrouselCategories hidden={showSearch || !isHome} />
          <MenuPlates />
        </div>

        {/* SIDEBAR DESKTOP — siempre presente si canUseCart, oculto visualmente en modal/cart */}
        {canUseCart && (
          <aside className={`${styles.sidebarColumn} ${isModal || isCart ? styles.sidebarHidden : ''}`}>
            <div className={styles.stickyWrapper}>
              <TotalCart orders={orders} total={total} desktop />
            </div>
          </aside>
        )}

      </div>

      {/* TotalCart MOBILE — fixed abajo, oculto en desktop */}
      {canUseCart && (
        <div className={`${styles.mobileTotal} ${isModal || isCart ? styles.hidden : ''}`}>
          <TotalCart orders={orders} total={total} />
        </div>
      )}

      {/* Footer */}
      <div className={isHome || isCart ? undefined : styles.hidden}>
        <FooterSection />
      </div>

      {/* Cart */}
      <Cart orders={orders} total={total} visible={isCart} />

      {/* PlateModal */}
      <PlateModal
        plate={plateToShow}
        cartItem={cartItemToEdit}
        menuData={menuData}
        onClose={handleCloseModal}
        visible={isModalVisible}
      />
    </>
  );
};

const FooterSection = () => (
  <div className={styles.containerFooter}>
    <p className={styles.footer}>
      Menú digital creado por&nbsp;<strong>menugraphic.com.ar</strong>
    </p>
  </div>
);
